import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import { FaBars } from 'react-icons/fa';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="main-header">
      <div className="logo-container">
        <img src="/images/Logo.png" alt="Harrygen Logo" className="logo-image" />
        <div><b>Harrygen Labs</b></div>
      </div>

      <div className="desktop-nav">
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/products">Our Products</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          <li><Link to="/presence"> Our Presence</Link></li>
        </ul>
      </div>

      <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
        <FaBars />
      </div>

      <div className={`mobile-nav ${isMobileMenuOpen ? 'active' : ''}`}>
        <ul>
          <li><Link to="/" onClick={toggleMobileMenu}>Home</Link></li>
          <li><Link to="/about" onClick={toggleMobileMenu}>About</Link></li>
          <li><Link to="/products" onClick={toggleMobileMenu}>Our Products</Link></li>
          <li><Link to="/contact" onClick={toggleMobileMenu}>Contact</Link></li>
          <li><Link to="/presence" onClick={toggleMobileMenu}>Presence</Link></li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
